import * as React from 'react'
// libs
import styled from 'styled-components'
// components
import { PopoverModal } from 'components/UI'
// themes
import { colors } from 'themes'
import MoreIcon from '@mui/icons-material/ArrowDropDown'
// utils
import isFunction from 'lodash/isFunction'

const MODAL_PROPS = {
  anchorOrigin: {
    vertical: 'bottom' as const,
    horizontal: 'right' as const
  },
  transformOrigin: {
    vertical: 'top' as const,
    horizontal: 'right' as const
  }
}

// styled
export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  min-width: 80px;
  border: none;
  background: transparent;
  color: ${colors.blue500};
  cursor: pointer;
`

const Item = styled.div`
  padding: 5px 15px;
  cursor: pointer;

  &:hover {
    background-color: ${colors.gray230};
  }
`

const Menu: React.FunctionComponent<any> = ({ title, options = [] }) => {
  return (
    <PopoverModal
      {...MODAL_PROPS}
      trigger={
        <Button>
          {title} <MoreIcon color={'inherit'} fontSize={'large'} />
        </Button>
      }>
      {({ closePopup }) =>
        options.map((option) => {
          const onOptionClick = () => {
            if (isFunction(option.onClick)) {
              option.onClick(closePopup)
            }
          }

          return (
            <Item key={option.label} onClick={onOptionClick}>
              {option.label}
            </Item>
          )
        })
      }
    </PopoverModal>
  )
}

export default Menu
